module.exports = __webpack_public_path__ + "img/10xcapital.d8795286.png";